"use strict";
var MetadataStorage_1 = require("./metadata/MetadataStorage");
/**
 * Default metadata storage is used as singleton and can be used to storage all metadatas.
 */
exports.defaultMetadataStorage = new MetadataStorage_1.MetadataStorage();

//# sourceMappingURL=storage.js.map



//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/storage.js
// module id = 916
// module chunks = 3